<template>
  <div class="content">
    <!-- 面包屑 -->
    <!-- <div class="breadcrumb">
      <i class="iconfont icondqwz"></i>
      <ul>
        <li class="active">设备管理</li>
      </ul>
    </div> -->
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i>严重告警配置
        </span>
        <div class="normalNav zaddBtn">
          <button class="OrangeSmBtn" @click="$refs.alarmRule.toAddNew()">编辑</button>
        </div>
        <div class="searchForm1">
          <!-- <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
          </searchForm> -->
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <!-- 后端分页 -->
          <easyTable apiUrl="operation/dangerRuleApi/findDangerRuleAll" :parent="self" :config="config" :other="other" ref="table_jsgl">
            <template slot="last">
              <el-table-column label="操作" width="100" align="left">
                <template slot-scope="scope">
                  <!-- <el-link icon="iconfont iconedit" type="text" size="small" @click="$refs.alarmRule.toEdit(scope.$index, scope.row)">编辑</el-link> -->
                  <el-link icon="iconfont icondelete" type="text" size="small" @click="deleteMsg(scope.$index, scope.row)">删除</el-link>
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>
      </el-tab-pane>
    </el-tabs>
    <add-dialog ref="alarmRule" :systemArr='systemArr'></add-dialog>
  </div>
</template>

<script>
import { dt, obj2urlsp } from "utils";
export default {
  data() {
    return {
      tabName: "jsgl",
      loading: true,
      form_jsgl: {},
      showTable: true,
      other: {},
      //分页
      message: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      //设备列表数据
      tableData2: [],
      items: [],
      systemArr: [],
    };
  },
  computed: {
    self() {
      return this;
    },
    config() {
      return [
        {
          prop: "systemName",
          label: "应用系统",
        },
        {
          prop: "typeNames",
          label: "设备类型",
        },
      ];
    },
    dt() {
      return dt.map(({ label }) => label);
    },
  },
  components: {
    normalNav: () => import("public/normalNav"),
    addDialog: () => import("./addDialog"),
    easyTable: () => import("public/easyTable"),
  },
  methods: {
    getInfo() {
      this.$axiosget(
        "manager/operatingSystemApi/getOperatingSystemsAndTypes/".concat(
          localStorage.getItem("companyId")
        )
      ).then(res => {
        this.systemArr = res.data.data;
      });
    },
    //删除
    deleteMsg(index, row) {
      this.$confirm("删除该条数据?", "删除操作", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axiospost(
          "operation/dangerRuleApi/deleteDangerRule/".concat(row.id)
        ).then(res => {
          if (res.data.status === "10000") {
            this.$refs.table_jsgl.getData();
            this.$message.success("删除成功");
          }
        });
      }).catch(()=>{

      })
    },
  },
  mounted() {
    this.getInfo();
  },
};
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/device/alarm/alarmRules/index.vue